import React from 'react';
import BaseModal from '../types/Base';
import {connect} from 'react-redux';
import {_removeModal} from '../../../store';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import {PORTAL_NAME} from '../../../../config';

const _Content = styled.div`
  color: ${(props) => props.theme.dark ? 'rgba(255, 255, 255, 0.7)' : 'rgba(0, 0, 0, 0.7)'};
  margin: 5px;
`;

const securityPolicy = <_Content>
  <h3>Safe and Secure</h3>
  <p>We partner with Yodlee and use bank-level encryption for all data storage and transfers.</p>

  <h3>Security Architecture</h3>
  <h4>We do not store credentials</h4>
  <p>Because of CircleBlack&apos;s partnership with Yodlee, we do not need to and thus never store your banking credentials.
    After the one-time setup, CircleBlack communicates with Yodlee via authentication tokens unique to our service, and
    relies on Yodlee&apos;s decade-long experience in connecting with financial institutions to read your portfolio details
    so we can make recommendations.</p>

  <h4>Bank-level security</h4>
  <p>CircleBlack uses 256-bit SSL encryption for all information transfers, the same connection banks use. In addition, our
    practices are monitored and secured by Qualisys.</p>
</_Content>;

const Disclosures = props => {
  const {dispatchRemoveModal, content} = props;

  return <BaseModal onClose={() => dispatchRemoveModal(content)} title={'Security Policy'} size={PORTAL_NAME === 'investor' ? 'md' : 'lg'}>
    {securityPolicy}
  </BaseModal>;
};

const mapDispatchToProps = dispatch => ({
  dispatchRemoveModal: modal => {
    dispatch(_removeModal(modal));
  },
});

export default connect(null, mapDispatchToProps)(Disclosures);

Disclosures.propTypes = {
  dispatchRemoveModal: PropTypes.func.isRequired,
  content: PropTypes.object,
};
